<template>
  <div class="slots">
    <h1>Blockerade slots</h1>

    <ul v-if="timeSlots.length">
      <li v-for="slot in timeSlots" :key="slot.id">
        <button :class="['button', {'is-selected': blockedSlots.includes(slot.id)}]" @click.prevent="selectTimeSlot(slot.id)">
          {{ slot.time }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { clone, get } from 'lodash';

  export default {
    name: 'BlockedSlots',
    data () {
      return {
        blockedSlots: []
      };
    },
    computed: {
      ...mapState('order', ['timeSlots']),
      ...mapState('order', ['settings'])
    },

    watch: {
      settings (settings) {
        this.blockedSlots = clone(settings.blockedSlots.data);
      }
    },

    mounted () {
      if (get(this, 'settings.blockedSlots.data')) {
        this.blockedSlots = clone(this.settings.blockedSlots.data);
      }
    },

    methods: {
      selectTimeSlot (slot) {
        if (this.blockedSlots.includes(slot)) {
          this.blockedSlots = this.blockedSlots.filter(s => s !== slot);
        } else {
          this.blockedSlots.push(slot);
        }

        this.$emit('blockedSlots', this.blockedSlots);
      }
    }
  };
</script>

<style lang="stylus" scoped>
  @require '~global/colors'
  @require '~global/typo-admin'
  @require '~global/helpers'
  .slots
    margin-bottom: 1rem

  h1
    font-weight: 500;
    margin-bottom: 1rem

  ul
    display: grid
    grid-template-columns: repeat(5, 4.7rem)
    line-height: 0
    grid-gap: .5rem 1rem
    justify-content: flex-start

  .button
    background: white
    color: $grey-dark
    padding: .6rem 1.2rem
    border-radius: 8px
    border: 1px solid $grey-light
    margin: 0

  .button:hover
    cursor: pointer

  .button:hover, .button.is-selected
    background: $off-black
    color: $white

  p
    text-align: center

  @media all and (-ms-high-contrast: none)
    *::-ms-backdrop, ul
      display: flex
      flex-wrap: wrap

    *::-ms-backdrop, li
      margin: .4rem

  @media (max-width: 454px)
    ul
      grid-template-columns: repeat(4, 4.7rem)

  @media (max-width: 362px)
    ul
      grid-template-columns: repeat(3, 4.7rem)
</style>
